import BaseSetup from '@/components/BaseSetup';
import { getAgencyAsideNavigation, getClientAsideNavigation, getTempWorkerAsideNavigation } from '@/utils/asideNavigationItems';
import { Reactive } from '@/utils/decorators';
import { ref, watch } from 'vue';

type Marker = {
	label: string
	value: boolean | number
};

export type SharedAsideNavigationEmits = {};
export type SharedAsideNavigationProps = {
	page: string
	markers?: Marker[]
};

export default class SharedAsideNavigationSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _navAside = ref<OrionNavMain>();

	@Reactive private readonly state = { asideNavigation: [] as Armado.AsideNavigationItemChildren[] };

	get asideNavigation () { return this.state.asideNavigation }

	constructor (
		private props: SharedAsideNavigationProps,
		private emits: SharedAsideNavigationEmits,
	) {
		super();

		watch(() => this.props.markers, () => {
			this.setMarkers();
		});
	}

	private setAsideNavigation () {
		if (this.self.isAgency()) this.state.asideNavigation = getAgencyAsideNavigation()[this.props.page];
		if (this.self.isClient()) this.state.asideNavigation = getClientAsideNavigation()[this.props.page];
		if (this.self.isTempWorker()) {
			this.state.asideNavigation = getTempWorkerAsideNavigation()[this.props.page];
		}
		else return [];
	}

	protected onMounted () {

		this.setAsideNavigation();
		if (this.props.markers) {
			this.setMarkers();
		}
	}

	private setMarkers () {
		this.props.markers?.forEach((marker: Marker) => {
			this.asideNavigation.forEach((item) => {
				if (marker.label === item.label) {
					item.marker = marker.value;
				}
			});
		});
	}

}
